jQuery(document).ready(function ($) {
    
    if($('.zahlenunddaten').length>0){

        $('.zahlenunddaten').each(function(){
            var top = 150;
            var zahlenContainer = $(this);
            var containerWidth = $(this).width();

            
            

            var zahlen = $(this).find('.zahlenelement');
            var zahlWidth = zahlen.first().width(); 

            var zahlenAnzahl = zahlen.length;

           // console.log(containerWidth);
           // console.log(zahlenAnzahl);
            

            var countZahlen = 0; 

            // wozu? ergibt keinen sinn
            //var korrektur = (zahlWidth/2) / (zahlenAnzahl-1);
            //console.log(korrektur);

            var baseLeft = (containerWidth / zahlenAnzahl); // + korrektur ;

           // console.log(baseLeft);
            
            var allZahlenArray = [[]];

            zahlen.each(function(){
                allZahlenArray[countZahlen] = [$(this)];
                if(countZahlen - 1 >= 0){
                    allZahlenArray[countZahlen - 1][1] = $(this);
                }
              //  console.log(allZahlenArray);
                var left = (countZahlen * baseLeft);
                
                $(this).css({
                    'left' : left
                }).addClass('renderedZahl');
                $(this).data('posx',left).attr('data-posx',left);
                if(countZahlen%2 != 0){
                    $(this).data('posy',top).attr('data-posy',top);
                }
                
                if(countZahlen > 0){
                    zahlenContainer.append('<div class="line from'+(countZahlen-1)+'to'+countZahlen+'"></div>');
                }
                countZahlen++;
            });

            //console.log(allZahlenArray);

             
                    for(var i = 0; i < allZahlenArray.length; i++){
                        var lineID = 'from'+(i)+'to'+(i+1);
                        var lineELement = $(this).find('.'+lineID).get(0);                        
                        if(lineELement){
                            adjustLine($,
                                allZahlenArray[i][0],  
                                allZahlenArray[i][1],
                                lineELement
                              );
                        }
                       
                    }

           

        });

        
    }

});



function adjustLine($, from, to, line){
    
    //console.log(from);

  var fT = parseFloat(from.data('posy')  + from.height()/2);
  var tT = parseFloat(to.data('posy') 	 + to.height()/2);
  var fL = parseFloat(from.data('posx') + from.width()/2);
  var tL = parseFloat(to.data('posx')	 + to.width()/2);
  
  // console.log("From Top: "+fT);
  // console.log("From Left: "+fL);
  // console.log("To Top: "+tT);
  // console.log("To Left: "+tL);

  // console.log(tT - fT);

  var CA   = Math.abs(tT - fT); 
  var CO   = Math.abs(tL - fL); 
  var H    = Math.sqrt(CA*CA + CO*CO); 
  var ANG  = 180 / Math.PI * Math.acos( CA/H );

  if(tT > fT){
      var top  = (tT-fT)/2 + fT;
  }else{
      var top  = (fT-tT)/2 + tT;
  }
  if(tL > fL){
      var left = (tL-fL)/2 + fL;
  }else{
      var left = (fL-tL)/2 + tL;
  }

  if(( fT < tT && fL < tL) || ( tT < fT && tL < fL) || (fT > tT && fL > tL) || (tT > fT && tL > fL)){
    ANG *= -1;
  }
  top-= H/2;
  
  line.style["-webkit-transform"] = 'rotate('+ ANG +'deg)';
  line.style["-moz-transform"] = 'rotate('+ ANG +'deg)';
  line.style["-ms-transform"] = 'rotate('+ ANG +'deg)';
  line.style["-o-transform"] = 'rotate('+ ANG +'deg)';
  line.style["-transform"] = 'rotate('+ ANG +'deg)';
  line.style.top    = top+'px';
  line.style.left   = left+'px';
  line.style.height = H + 'px';
  line.classList.add('renderedLine');
}
/*
adjustLine(
  document.getElementById('div1'), 
  document.getElementById('div2'),
  document.getElementById('line')
);

*/